import React from 'react';
import { useIsMobile } from '../../hooks/useResponsive';
import { useUrlState } from '../../hooks/useUrlState';
import { usePortfolioData } from './hooks/usePortfolioData';
import { usePropertyTabContainer } from './hooks/usePropertyTabContainer';
import { useCaptureToolsLoading } from './hooks/useCaptureToolsLoading';
import { useGlobalTags } from '../../hooks/useGlobalTags';
import MobileLayout from './mobile/MobileLayout';
import DesktopLayout from './desktop/DesktopLayout';

/**
 * Main Capture Tools container.
 *
 * State layers:
 *   URL state   → activeTab (portfolio / properties / responses / qr)
 *   Global      → properties & portfolio cached in Zustand (via hooks)
 *   Local       → editor UI interactions remain inside child components
 */
const CaptureTools = () => {
  const isMobile = useIsMobile();

  // ── URL state for active tab ──
  const [activeTab, setActiveTab] = useUrlState('tab', 'portfolio');

  // Firestore-backed portfolio state
  const portfolio = usePortfolioData();

  // Firestore-backed property state (replaces mock data)
  const propertyTab = usePropertyTabContainer();

  // Global tags derived from all leads (unified tag ecosystem)
  const availableTags = useGlobalTags();

  // Unified loading state for actual data operations
  const loadingState = useCaptureToolsLoading({
    portfolioLoading: portfolio.loading,
    propertyLoading: propertyTab.loading,
    uploading: propertyTab.uploading,
  });

  if (isMobile) {
    return (
      <MobileLayout
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        propertyTab={propertyTab}
        portfolio={portfolio}
        loadingState={loadingState}
        availableTags={availableTags}
      />
    );
  }

  return (
    <DesktopLayout
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      propertyTab={propertyTab}
      portfolio={portfolio}
      loadingState={loadingState}
      availableTags={availableTags}
    />
  );
};

export default CaptureTools;
